import React from 'react';
import Icon from '../../../components/AppIcon';

const BillingOverview = ({ subscription, hasActiveSubscription, userProfile, onManageSubscription }) => {
  const getNextPaymentDate = () => {
    if (!subscription?.currentPeriodEnd) return 'N/A';
    return new Date(subscription?.currentPeriodEnd)?.toLocaleDateString('en-US', {
      month: 'long',
      day: 'numeric',
      year: 'numeric'
    });
  };

  const getSubscriptionAmount = () => {
    if (userProfile?.tier === 'pro') return '$11.99';
    return '$0.00';
  };

  const getStatusColor = () => {
    if (!hasActiveSubscription) return 'bg-gray-100 text-gray-700';
    if (subscription?.status === 'active') return 'bg-green-100 text-green-700';
    if (subscription?.status === 'trialing') return 'bg-blue-100 text-blue-700';
    if (subscription?.status === 'past_due') return 'bg-red-100 text-red-700';
    return 'bg-gray-100 text-gray-700';
  };

  const getStatusText = () => {
    if (!hasActiveSubscription) return 'Free Plan';
    if (subscription?.status === 'active') return 'Active';
    if (subscription?.status === 'trialing') return 'Trial';
    if (subscription?.status === 'past_due') return 'Past Due';
    if (subscription?.status === 'canceled') return 'Canceled';
    return 'Unknown';
  };

  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
      {/* Current Plan */}
      <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
        <div className="flex items-center justify-between mb-4">
          <div className="p-2 bg-blue-50 rounded-lg">
            <Icon name="CreditCard" className="w-6 h-6 text-blue-600" />
          </div>
          <span className={`px-3 py-1 rounded-full text-xs font-medium ${getStatusColor()}`}>
            {getStatusText()}
          </span>
        </div>
        <h3 className="text-sm font-medium text-gray-600 mb-1">Current Plan</h3>
        <p className="text-2xl font-bold text-gray-900 mb-1">
          {userProfile?.tier === 'pro' ? 'Pro' : 'Free'}
        </p>
        <p className="text-sm text-gray-500">
          {getSubscriptionAmount()}/month
        </p>
      </div>

      {/* Next Payment */}
      <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
        <div className="flex items-center justify-between mb-4">
          <div className="p-2 bg-green-50 rounded-lg">
            <Icon name="Calendar" className="w-6 h-6 text-green-600" />
          </div>
        </div>
        <h3 className="text-sm font-medium text-gray-600 mb-1">Next Payment</h3>
        <p className="text-2xl font-bold text-gray-900 mb-1">
          {hasActiveSubscription ? getSubscriptionAmount() : 'N/A'}
        </p>
        <p className="text-sm text-gray-500">
          {hasActiveSubscription ? `Due ${getNextPaymentDate()}` : 'No upcoming payment'}
        </p>
      </div>

      {/* Account Balance */}
      <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
        <div className="flex items-center justify-between mb-4">
          <div className="p-2 bg-purple-50 rounded-lg">
            <Icon name="Wallet" className="w-6 h-6 text-purple-600" />
          </div>
        </div>
        <h3 className="text-sm font-medium text-gray-600 mb-1">Account Balance</h3>
        <p className="text-2xl font-bold text-gray-900 mb-1">$0.00</p>
        <p className="text-sm text-gray-500">No outstanding balance</p>
      </div>

      {/* Manage Subscription Button */}
      {hasActiveSubscription && (
        <div className="md:col-span-3">
          <button
            onClick={onManageSubscription}
            className="w-full flex items-center justify-center gap-2 px-6 py-3 bg-blue-600 text-white font-medium rounded-lg hover:bg-blue-700 transition-colors"
          >
            <Icon name="Settings" className="w-5 h-5" />
            Manage Subscription & Billing
          </button>
        </div>
      )}
    </div>
  );
};

export default BillingOverview;